import murmurhash from 'murmurhash-js';
import { isObject } from 'lodash-es';
const HASH_KEY = 0x9747b28c;
export const JSTORAGE_KEY = 'jStorage';
// noinspection SpellCheckingInspection
const INITIAL_DATA = {
    __jstorage_meta: {
        CRC32: {},
        TTL: {}
    }
};
export class JStorageService {
    get(key) {
        return this.getDataFromStorage()[key];
    }
    set(key, value) {
        const jStorage = this.getDataFromStorage();
        jStorage[key] = value;
        jStorage.__jstorage_meta.CRC32[key] = this.calculateChecksum(value);
        localStorage.setItem(JSTORAGE_KEY, JSON.stringify(jStorage));
    }
    setMultiple(changes) {
        Object.keys(changes).forEach(key => this.set(key, changes[key]));
    }
    deleteKey(key) {
        const jStorage = this.getDataFromStorage();
        delete jStorage[key];
        delete jStorage.__jstorage_meta.CRC32[key];
        localStorage.setItem(JSTORAGE_KEY, JSON.stringify(jStorage));
    }
    clear() {
        // Remove the persisted blob
        localStorage.removeItem(JSTORAGE_KEY);
    }
    getDataFromStorage() {
        const jStorageStr = localStorage.getItem(JSTORAGE_KEY);
        if (!jStorageStr) {
            return { ...INITIAL_DATA };
        }
        const jStorageObject = JSON.parse(jStorageStr);
        if (!isObject(jStorageObject)) {
            return { ...INITIAL_DATA };
        }
        if (!jStorageObject.hasOwnProperty('__jstorage_meta')) {
            return { ...INITIAL_DATA, ...jStorageObject };
        }
        return JSON.parse(jStorageStr);
    }
    calculateChecksum(value) {
        // Handle undefined/null values gracefully
        // JSON.stringify(undefined) returns undefined, not a string
        // JSON.stringify(null) returns the string "null"
        if (value === undefined) {
            return `2.${murmurhash.murmur2('undefined', HASH_KEY)}`;
        }
        if (value === null) {
            return `2.${murmurhash.murmur2('null', HASH_KEY)}`;
        }
        const stringifiedValue = JSON.stringify(value);
        // JSON.stringify can return undefined for certain values (like undefined itself), handle that case
        if (stringifiedValue === undefined) {
            return `2.${murmurhash.murmur2('undefined', HASH_KEY)}`;
        }
        const resultHash = murmurhash.murmur2(stringifiedValue, HASH_KEY);
        return `2.${resultHash}`;
    }
}
//# sourceMappingURL=j-storage.service.js.map